import api from './api';

export interface ClientAddress {
  street: string;
  number: string;
  complement?: string;
  neighborhood: string;
  city: string;
  state: string;
  zipCode: string;
  coordinates?: {
    lat: number;
    lng: number;
  };
}

export interface ClientContact {
  name?: string;
  position?: string;
  phone?: string;
  email?: string;
}

export interface Client {
  _id?: string;
  name: string;
  documentType: 'CPF' | 'CNPJ';
  documentNumber: string;
  clientType: 'individual' | 'company' | 'government' | 'other';
  email?: string;
  phone?: string;
  address: ClientAddress;
  contactPerson?: ClientContact;
  notes?: string;
  isActive: boolean;
  sla: string | { _id: string; name: string; responseTime: number; resolutionTime: number };
  createdAt?: string;
  updatedAt?: string;
}

export interface ClientsResponse {
  clients: Client[];
  pagination: {
    total: number;
    page: number;
    limit: number;
    pages: number;
  };
}

export interface ClientParams {
  page?: number;
  limit?: number;
  search?: string;
  clientType?: string;
  isActive?: boolean;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
}

const clientService = {
  // Get all clients with pagination and filters
  getClients: async (params: ClientParams = {}): Promise<ClientsResponse> => {
    const response = await api.get('/clients', { params });
    return response.data;
  },

  // Get a single client by ID
  getClientById: async (clientId: string): Promise<{ client: Client }> => {
    const response = await api.get(`/clients/${clientId}`);
    return response.data;
  },

  // Create a new client
  createClient: async (clientData: Omit<Client, '_id' | 'createdAt' | 'updatedAt'>) => {
    const response = await api.post('/clients', clientData);
    return response.data;
  },

  // Update a client
  updateClient: async (clientId: string, clientData: Partial<Client>) => {
    if (!clientId) {
      throw new Error('ID do cliente não fornecido. Impossível atualizar.');
    }
    
    // Verificar se o campo sla é um objeto e extrair apenas o ID se for o caso
    if (clientData.sla && typeof clientData.sla === 'object' && '_id' in clientData.sla) {
      clientData.sla = clientData.sla._id;
    }
    
    console.log(`Atualizando cliente com ID: ${clientId}`);
    console.log('Dados para atualização:', clientData);
    
    try {
      const response = await api.put(`/clients/${clientId}`, clientData);
      return response.data;
    } catch (error: any) {
      console.error(`Erro ao atualizar cliente ${clientId}:`, error.response?.data || error.message);
      throw error;
    }
  },

  // Delete a client
  deleteClient: async (clientId: string) => {
    const response = await api.delete(`/clients/${clientId}`);
    return response.data;
  },

  // Get client assets
  getClientAssets: async (clientId: string, page = 1, limit = 10) => {
    const response = await api.get(`/clients/${clientId}/assets`, {
      params: { page, limit }
    });
    return response.data;
  }
};

export default clientService;
